import { literal, struct } from 'io-ts/Decoder';

import { ParentId } from '../file/ParentId';

import { Id as FolderId } from './Id';

export const ComplexId = struct({
	parentId: ParentId,
	folderId: FolderId,
});

export const VirtualComplexId = struct({
	parentId: ParentId,
	folderId: literal(null),
});

export const RootComplexId = struct({
	parentId: ParentId,
	folderId: literal(null),
});
